<div class="chart">
  <canvas baseChart (chartClick)="onChartClick()" [data]="pieChartData" [labels]="pieChartLabels"
    [chartType]="pieChartType" [options]="pieChartOptions" [plugins]="pieChartPlugins" [colors]="pieChartColors"
    [legend]="pieChartLegend">
  </canvas>
</div>